import React from 'react';
import {ListGroupItem, ListGroup} from 'reactstrap'

/**
 * @param {string} graderMessage 
 * @param {object} graderResult 
 */
export function renderTestCasesInformation(graderMessage, graderResult) {
    if(graderMessage !== "Ocenjivanje završeno" || graderResult === null) {
        return(<div></div>);
    } else {
        switch(graderResult.state) {
            case "compile_err": return(compileErrorInfo(graderResult.message));
            case "malformed_request": return(malformedRequestInfo(graderResult.message));
            case "internal_error": return(internalErrorInfo(graderResult.message));
            case "finished": return(finishedInfo(graderResult));
            default: console.log("Nepoznato stanje"); break;
        }
    }
}

/****************************HELPERS****************************/
function compileErrorInfo(message) {
    return (
        <React.Fragment>
            <div className={'row'}>
                Greška u kompilaciji: <br/>
                <pre style={{fontSize:'14px', fontStyle:'italic', color:"rgb(136, 189, 188)"}}> {message.trim()}</pre>
            </div>
        </React.Fragment>

    );
}

function malformedRequestInfo(message) {
    return (
        <React.Fragment>
            <div className={'row'}>
                Greška u radu aplikacije(malformed request). Molimo Vas da obavestite nastavnika/administratora.
                <br/><br/>
                <pre style={{fontSize:'14px', fontStyle:'italic', color:"rgb(136, 189, 188)"}}> Sistemska poruka: <br/> {message}</pre>
            </div>
        </React.Fragment>

    );
}

function internalErrorInfo(message) {
    return (
        <React.Fragment>
            <div className={'row'}>
                Greška u radu aplikacije(internal error). Molimo Vas da obavestite nastavnika/administratora.
                <br/><br/>
                <pre style={{fontSize:'14px', fontStyle:'italic', color:"rgb(136, 189, 188)"}}> Sistemska poruka: <br/> {message}</pre>
            </div>
        </React.Fragment>

    );
}

function finishedInfo(graderResult) {
    var tmp = getTestsInfo(graderResult);
    var testsInfo = tmp.testsInfo;
    var len = tmp.len;
    var numOfCorrectCases = tmp.numOfCorrectCases;
    var header = "";

    return (
        <React.Fragment>
            <div className={'row text-center'}>
                {header}
            </div>
            <ListGroup> {testsInfo} </ListGroup>
            <br/>
            <span> Ukupan skor: {numOfCorrectCases}/{len} </span>
        </React.Fragment>
    );
}

/**
 * @param {bool} correct 
 * @param {string} msg 
 * @param {string} sysmsg 
 * @param {int} index 
 * @description creates listGroupItem for test case
 */
function createTestInfo(correct, msg, sysmsg, index) {
    return (
        <ListGroupItem key={index}>
            <div className={''}>
                {
                    correct ?
                        <span className="fa fa-check-circle" style={{color:'green', fontSize:'20px'}}></span>
                        :
                        <span className="fa fa-times-circle" style={{color:'red', fontSize:'20px'}}></span>
                }
                <span style={{marginLeft:'10px'}}>
                    {"TEST " + index + ": " + msg}
                </span>
                {
                    sysmsg !== "" ?
                        <React.Fragment>
                            <br/>
                            <span style={{fontSize:'14px', fontStyle:'italic'}}> Sistemska poruka: <br/> {sysmsg}</span>
                        </React.Fragment> : ""
                }
            </div>
        </ListGroupItem>
    );
}

/**
 * @param {object} graderResult 
 * @description creates array of formated test cases
 */
    function getTestsInfo(graderResult) {
    var tests = graderResult.tests;
    var len = graderResult.tests.length;
    var numOfCorrectCases = 0;
    tests=tests.map((test, index)=>{
        //attention unknown passenger
        //this switch doesn't have any break statements because it has returns. If you are to change it, don't forget to add breaks.
        switch(test.status){
            case "finished":
                if (test.output === 1) { // Everything is correct
                    ++numOfCorrectCases;
                    return createTestInfo(true, "Izlaz je dobar za ovaj test primer", "", index);
                }
                else  // Wrong output
                    return createTestInfo(false,
                        "Pogrešan izlaz iz programa ili pogrešan završni kod programa (eng. exit code).",
                        "", index);
            case "time":
                return createTestInfo(false, "Prekoračeno je vremensko ograničenje.", "", index);
                
            case "interrupted":
                return createTestInfo(false,
                                    "Vaš program se zaglavio (na primer blokira na učitavanju) ili je sistem preopterećen (manje verovatno).",
                                    "", index);
            case "memory":
                return createTestInfo(false, "Prekoračeno je memorijsko ograničenje.", "", index);
                
            case "skipped":
                return createTestInfo(false,
                                    "Test nije izvršen zbog prethodnih testova koje Vaš program nije uspešno rešio.",
                                    "", index);
            case "killed":
                return createTestInfo(false,
                                    "Program je prekinut zbog greške u izvršavanju (na primer neispravan pristup memoriji, deljenje nulom i sl.). Pogledajte sistemsku poruku.",
                                    test.message + ". Broj signala operativnog sistema: " + test.signum + ".", index);     
            default:
                return createTestInfo(false, "Nepoznat status programa", "Primljeni status je '" + test.status + "'.", index);
        }
    });
    let ret = {testsInfo: tests, len:len, numOfCorrectCases:numOfCorrectCases};
    return(ret);
}
